<template>
  <WriteWarranty/>
</template>
<script>
import WriteWarranty from 'place/warranty/writeWarranty.vue'
export default {
    components:{
      WriteWarranty
    }
}
</script>